import { ReactComponent as SVGRaindropLogoWithTitle } from "./raindrop-logo-with-title.svg";

export default SVGRaindropLogoWithTitle;
